import {api} from './requestGraphql'
import {reFormatJSON} from "../helpers";

const getOffer = async (id) => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getOffer(id:${id}) {
              id
              name
              advertiserId
              advertiserName
              advertiserManagerId
              verticalId
              verticalName
              conversionType
              currencyId
              status
              payIn
              payOut
              isCpmOptionEnabled
              descriptions
              restrictions
              payoutPercent
              marginType
              dateAdded
              geoRules
              defaultLp
              offerIdRedirect
              exitTrafficOfferName
              programId
              customLPRules
              useStartEndDate
              startDate
              endDate
              isRestricted
              type
              externalId
              internalNotes
              previewLink
            }
          }

        `,
      }
    )

    let response = res.data.data.getOffer
    return response
  } catch (e) {
    console.error(e)
  }

}

const getOffersAggregated = async (id) => {

  try {
    const res = await api.post(
        '', {
          query: `
          {
            getOffersAggregated(id:${id}) {
                id
                name
                advertiserId
                advertiserName
                landingPageId
                landingPageUrl
                verticalName
                payIn
                payOut
                status              
            }
          }
        `,
        }
    )

    let response = res.data.data.getOffersAggregated
    return response
  } catch (e) {
    console.error(e)
  }
}

const lpOffers = async (offerId) => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getLpOffers(offerId:${offerId}) {
              id
              name
              url
              status
              offerId
            }
          }
        `,
      }
    )

    let response = res.data.data.getLpOffers
    console.log('\nlpOffers from DB response count:', response.length)
    return response
  } catch (e) {
    console.log(e)
  }

}

const createLpOffer = async (data) => {

  const {name, url, offerId} = data

  try {
    const res = await api.post(
      '', {
        query: `
          mutation {
            createLpOffer(
              name:"${name}",
              url:"${url}",
              offerId:${offerId}) {
              id
            }
          }

        `,
      }
    )

    let response = res.data.data.createLpOffer
    console.log('\ncreateLpOffer response:', response)
    console.timeEnd(`lp`)
    return response
  } catch (e) {
    console.log(e)
  }

}

const createOffer = async (data) => {
  let {name, type} = data
  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            createOffer(
              name:"${name}"
              type:"${type}"
            ){
              id
            }
          },

        `,
      }
    )

    let response = res.data.data.createOffer
    console.log(`\ncreate Offer count: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }

}


const getOfferCap = async (offerId) => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getOfferCap(offerId:${offerId}) {
              offerId
              clickDay
              clickWeek
              clickMonth
              clicksRedirectStatus
              clicksRedirectOfferId
              clickExitTrafficOfferName
              clicksRedirectOfferUseDefault
              salesDay
              salesWeek
              salesMonth
              salesRedirectStatus
              salesRedirectOfferId
              saleExitTrafficOfferName
              salesRedirectOfferUseDefault
              useStartEndDate
              startDate
              endDate
              enabled
            }
          }

            `,
      }
    )

    let response = res.data.data.getOfferCap
    console.log(`\ngetOfferCap count: { ${response ? response.length: 0} }  by id: { ${offerId} } `)
    return response
  } catch (e) {
    console.error(e)
  }

}

const getExitTrafficOffers = async (data) => {

  const search = data && `(search: "${data.search}")` || ''
  try {
    const res = await api.post(
        '', {
          query: `
          {
            getExitTrafficOffers ${search}{
              id
              name
              nameId
              advertiserId
              advertiserName
              landingPageId
              landingPageUrl
              verticalName
              payIn
              payOut
              status
            }
          }
            `,
        }
    )
    let response = res.data.data.getExitTrafficOffers

    return response
  } catch (e) {
    console.error(e)
  }
}

const saveOffer = async (data) => {
  const emojiRegex = /[\p{Emoji}]/gu;
  let {
    advertiserId,
    advertiserName,
    advertiserManagerId,
    verticalId,
    verticalName,
    conversionType,
    currencyId,
    geoRules,
    payoutPercent,
    isCpmOptionEnabled,
    descriptions,
    restrictions,
    customLPRules,
    id,
    name,
    payIn,
    payOut,
    status,
    defaultLp,
    defaultSiteName,
    caps,
    lp,
    offerIdRedirect,
    useStartEndDate,
    startDate,
    endDate,
    isRestricted,
    marginType,
    programId,
    externalId,
    internalNotes,
    previewLink
  } = data
  externalId = (externalId === null || externalId === "null") ? "" : externalId;

  let geoRulesArr
  if (geoRules) {
    geoRulesArr = JSON.parse(geoRules)
  } else {
    let geoDefault = {}
    geoDefault.geo = []
    geoRulesArr = geoDefault
  }

  let geoRulesReFormat = JSON.stringify(geoRulesArr).replace(/"/g, '\\"')


  let customLPRulesArr
  if (customLPRules) {
    customLPRulesArr = JSON.parse(customLPRules)
  } else {
    let customLpDefault = {}
    customLpDefault.customLPRules = []
    customLPRulesArr = customLpDefault
  }

  let customLPRulesReFormat = JSON.stringify(customLPRulesArr).replace(/"/g, '\\"')


  let capsFormat = caps && JSON.stringify(caps).replace(/"/g, '\\"') || ''
  let lpFormat = lp && JSON.stringify(lp).replace(/"/g, '\\"') || ''

  if (descriptions) {
    descriptions = descriptions.replace(emojiRegex, (emoji) => encodeURIComponent(emoji));
  }


  try {
    const res = await api.post(
      '', {
        query: `
            mutation{
                  saveOffer(
                        id:${id}
                        name:"${name}"
                        status:"${status}"
                        advertiserId:${advertiserId}
                        advertiserManagerId:${advertiserManagerId}
                        advertiserName:"${advertiserName}"
                        verticalId:${verticalId}
                        verticalName:"${verticalName}"
                        payoutPercent:${payoutPercent || 0}
                        isCpmOptionEnabled:${isCpmOptionEnabled}
                        descriptions:"""${replaceDoubleQuotesWithSingle(descriptions)}"""
                        restrictions:"""${restrictions}"""
                        internalNotes:"""${internalNotes}"""
                        previewLink:"""${previewLink}"""
                        conversionType:"${conversionType}"
                        currencyId:${currencyId}
                        geoRules:"${geoRulesReFormat}"
                        customLPRules:"${customLPRulesReFormat}"
                        payIn:${payIn}
                        defaultLp:${defaultLp}
                        defaultSiteName:"${defaultSiteName}"
                        offerIdRedirect:${offerIdRedirect}
                        caps:"${capsFormat}"
                        lp:"${lpFormat}"
                        payOut:${payOut}
                        useStartEndDate:${useStartEndDate}
                        startDate:"${startDate}"
                        endDate:"${endDate}"
                        isRestricted:${isRestricted}
                        marginType:"${marginType}"
                        programId:${programId}
                        externalId:"${externalId}"
                  ){
                        id
                  }
            },

            `,
      }
    )

    let response = res.data.data.saveOffer
    console.log(`\ncreate Offer count: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }

}

const saveOfferAggregated = async (data) => {
  const emojiRegex = /[\p{Emoji}]/gu;

  let {
    advertiserId,
    advertiserName,
    advertiserManagerId,
    verticalId,
    verticalName,
    conversionType,
    payoutPercent,
    isCpmOptionEnabled,
    descriptions,
    restrictions,
    offerAggregatedIds,
    id,
    name,
    payIn,
    payOut,
    status,
    offerIdRedirect,
    isRestricted,
    externalId,
    internalNotes,
  } = data

  externalId = (externalId === null || externalId === "null") ? "" : externalId;

  const offerAggregatedIdsToSend = offerAggregatedIds.length !==0 && JSON.stringify(offerAggregatedIds).replace(/"/g, '\\"') || '[]'

  if (descriptions) {
    descriptions = descriptions.replace(emojiRegex, (emoji) => encodeURIComponent(emoji));
  }

  try {
    const res = await api.post(
        '', {
          query: `
                    mutation{
                          saveOfferAggregated(
                                id:${id}
                                name:"${name}"
                                status:"${status}"
                                advertiserId:${advertiserId || 0}
                                advertiserManagerId:${advertiserManagerId}
                                advertiserName:"${advertiserName}"
                                verticalId:${verticalId}
                                verticalName:"${verticalName}"
                                payoutPercent:${payoutPercent}
                                isCpmOptionEnabled:${isCpmOptionEnabled}
                                descriptions:"""${replaceDoubleQuotesWithSingle(descriptions)}"""
                                restrictions:"""${restrictions}"""
                                internalNotes:"""${internalNotes}"""
                                conversionType:"${conversionType}"
                                offerAggregatedIds:"${offerAggregatedIdsToSend}"
                                payIn:${payIn}
                                payOut:${payOut}
                                offerIdRedirect:${offerIdRedirect}      
                                isRestricted:${isRestricted}                          
                                externalId:"${externalId}"                          
                          ){
                                id
                          }
                    },
            `,
        }
    )

    let response = res.data.data.saveOfferAggregated
    console.log(`\n Create Offer aggregated: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }
}


const updateOffer = async (
    {id, verticalId, externalId, conversionType, status, payIn, payOut, landingPage, landingPageId, programId, featured, shouldSendNotification, affiliateMultiPings}
    ) => {

    try {
        const res = await api.post(
            '', {
                query: `
                    mutation{
                          updateOffer(
                                id:${id}
                                verticalId:${verticalId}
                                conversionType: "${conversionType}"
                                status: "${status}"
                                payIn: ${payIn}
                                payOut: ${payOut}
                                programId: ${programId}
                                landingPage: "${landingPage}"
                                landingPageId: ${landingPageId}
                                featured: ${featured}
                                externalId: "${externalId}"
                                shouldSendNotification: ${shouldSendNotification}
                                affiliateMultiPings: ${affiliateMultiPings}
                          ){
                                id
                          }
                    },

            `,
            }
        )

        const response = res.data.data.updateOffer;
        console.log(`\ncreate Offer updated: { ${JSON.stringify(response)} } `)
        return response
    } catch (e) {
        console.log(e)
    }
}

const createMassOffers = async (data) => {

  let massOffersFormat = JSON.stringify(data).replace(/"/g, '\\"')

  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            createMassOffers(
              offers:"${massOffersFormat}"
            ){
              name
              error
              success
            }
          },

        `,
      }
    )

    let response = res.data.data.createMassOffers
    console.log(`\ncreateMassOffers : { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }

}

const delOffer = async (id) => {

  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            delOffer(
              id:${id}
            ){
              id
            }
          },

        `,
      }
    )

    let response = res.data.data.delOffer
    // console.log(`\ndelete Offer count: { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getPostback = async (id) => {

  try {
    const res = await api.post(
        '', {
          query: `
          {
            getPostback(advertiserId:${id}) {
              value
            }
          }
        `,
        }
    )

    let response = res.data.data.getPostback
    return response
  } catch (e) {
    console.log(e)
  }

}

const checkOfferNameExists = async (offerName) => {

  try {
    const res = await api.post(
      '', {
        query: `
          {
            checkOfferNameExists(offerName:"${offerName}") {
              count
            }
          }
        `,
      }
    )

    let response = res.data.data.checkOfferNameExists
    return response
  } catch (e) {
    console.log(e)
  }

}

const createDuplicateOffer = async (offerId) => {
  try {
    const res = await api.post('', {
      query: `
        mutation {
          createDuplicateOffer(
            offerId: ${offerId}
          ) {
            success
            newOfferId
            message
          }
        }
      `,
    });

    let response = res.data.data.createDuplicateOffer;
    return response;
  } catch (e) {
    console.log(e);
  }
};

const massStatusUpdate = async (offerIds, status) => {

  try {
    const res = await api.post('', {
      query: `
        mutation {
          massStatusUpdate(
            input: {
              offerIds: [${offerIds.join(',')}],
              newStatus: "${status}"
            }
          ) {
            success
            updatedCount
            message
          }
        }
      `,
    });

    let response = res.data.data.massStatusUpdate;
    return response;
  } catch (e) {
    console.log(e);
    throw new Error('Error updating status for offers');
  }
};

const uploadFiles = async (offerId, name, data, filesToDelete = []) => {
  try {
    const res = await api.post(
        '', {
          query: `
          mutation {
            uploadFile(
              offerId: ${offerId}
              name: "${name}"
              data: """${data}"""
            ) {
              success
              message
              fileUrl
            }
          }
        `,
        }
    );

    const response = res.data.data.uploadFile;
    return response;
  } catch (error) {
    console.log(error.message);
  }
};

const deleteFiles = async (offerId, filesToDelete = []) => {
  try {
    const res = await api.post(
        '',
        {
          query: `
            mutation DeleteFiles($files: [String!]!, $offerId: Int!) {
              deleteFiles(files: $files, offerId: $offerId)
            }
        `,
          variables: {
            files: filesToDelete,
            offerId: offerId
          },
        }
    );

    const response = res.data.data.deleteFiles;
    return response;
  } catch (error) {
    console.log(error.message);
  }
};

const getFiles = async (offerId) => {
  try {
    const res = await api.post(
        '', {
          query: `
            {
              getOfferFiles(offerId:${offerId}) {
                name,
                preview
              }
            }
        `,
        }
    );

    const response = res.data.data.getOfferFiles;
    return response;
  } catch (error) {
    console.log(error.message);
  }
};


function replaceDoubleQuotesWithSingle(str) {
  if (typeof str !== 'string') return str;
  return str.replace(/"/g, "'");
}

export default {
  lpOffers,
  createLpOffer,
  getOffer,
  getOffersAggregated,
  getOfferCap,
  createOffer,
  saveOffer,
  saveOfferAggregated,
  createMassOffers,
  delOffer,
  updateOffer,
  getPostback,
  getExitTrafficOffers,
  checkOfferNameExists,
  createDuplicateOffer,
  massStatusUpdate,
  uploadFiles,
  getFiles,
  deleteFiles
}
